// Единый источник данных по услугам: используется на главной и на /uslugi.
import { routes } from "./nav";

export type ServiceCard = {
  title: string;
  to: string;
  text: string;
  /** Понятная подпись ссылки вместо одинакового «Подробнее» */
  linkLabel: string;
  /** Дочерние SEO-посадочные направления */
  sublinks?: { label: string; to: string }[];
};

export type ServiceGroupData = {
  id: string;
  label: string;
  items: ServiceCard[];
};

/** Группы для страницы /uslugi (короткие описания, 2–3 предложения) */
export const serviceCatalog: ServiceGroupData[] = [
  {
    id: "sites",
    label: "Разработка сайтов",
    items: [
      {
        title: "Разработка сайтов",
        to: routes.sites,
        text: "Корпоративные сайты, лендинги, промосайты и сайты-каталоги под задачи бизнеса и маркетинга.",
        linkLabel: "Разработка сайтов",
        sublinks: [
          { label: "Лендинги и сайты на Tilda", to: routes.landing },
          { label: "Корпоративные сайты", to: routes.corporate },
        ],
      },
      {
        title: "Разработка интернет-магазинов",
        to: routes.ecom,
        text: "E-commerce-проекты с каталогом, оплатой, доставкой, интеграциями, аналитикой и SEO.",
        linkLabel: "Разработка интернет-магазинов",
      },
      {
        title: "Веб-сервисы и приложения",
        to: routes.webServices,
        text: "Личные кабинеты, B2B- и B2C-порталы, SaaS, внутренние системы и Mini Apps со сложной бизнес-логикой.",
        linkLabel: "Разработка веб-сервисов",
      },
    ],
  },
  {
    id: "marketing",
    label: "Интернет-маркетинг",
    items: [
      {
        title: "SEO-продвижение сайтов",
        to: routes.seo,
        text: "Техническая оптимизация, архитектура, контент и развитие органического трафика.",
        linkLabel: "SEO-продвижение сайтов",
      },
      {
        title: "Настройка и ведение Яндекс Директа",
        to: routes.context,
        text: "Стратегия, запуск, аналитика и регулярная оптимизация рекламных кампаний.",
        linkLabel: "Ведение Яндекс Директа",
      },
      {
        title: "Реклама в Яндекс Картах и 2ГИС",
        to: routes.geo,
        text: "Карточки организаций, реклама, отзывы, филиалы и аналитика действий пользователей.",
        linkLabel: "Продвижение в геосервисах",
      },
    ],
  },
  {
    id: "crm",
    label: "CRM и автоматизация",
    items: [
      {
        title: "Внедрение amoCRM",
        to: routes.amocrm,
        text: "Воронки продаж, автоматизация, интеграции, аналитика и обучение команды.",
        linkLabel: "Внедрение amoCRM",
      },
      {
        title: "Внедрение RetailCRM",
        to: routes.retailcrm,
        text: "Управление заказами, коммуникациями и CRM-маркетингом интернет-магазина.",
        linkLabel: "Внедрение RetailCRM",
      },
      {
        title: "Внедрение Битрикс24",
        to: routes.bitrix24,
        text: "CRM, корпоративный портал, бизнес-процессы и интеграции в одной системе.",
        linkLabel: "Внедрение Битрикс24",
      },
    ],
  },
  {
    id: "industry",
    label: "Отраслевые решения",
    items: [
      {
        title: "Digital для медицинских центров",
        to: routes.expert,
        text: "Сайты, маркетинг, аналитика и CRM с учётом специфики медицинских проектов.",
        linkLabel: "Digital для медицинских центров",
      },
      {
        title: "Цифровые решения для ломбардов",
        to: routes.lombard,
        text: "Разработка сайтов, личных кабинетов и цифровых сервисов для ломбардного бизнеса.",
        linkLabel: "Решения для ломбардов",
      },
      {
        title: "Маркетинг для ломбардов",
        to: routes.lombardMarketing,
        text: "Продвижение филиалов, реклама, SEO, геосервисы и аналитика обращений.",
        linkLabel: "Маркетинг для ломбардов",
      },
    ],
  },
];

/** Группы для блока «Наши услуги» на главной (развёрнутые описания) */
export const homeServiceGroups: ServiceGroupData[] = [
  {
    id: "sites",
    label: "Сайты",
    items: [
      {
        title: "Лендинги (Tilda)",
        to: routes.landing,
        linkLabel: "Сайты на Tilda",
        text: "Создаем продуманные лендинги, которые не просто рассказывают о вашем бизнесе, а продают. В работе участвуют маркетологи и UX-специалисты: делаем стильно и с прицелом на результат.",
      },
      {
        title: "Интернет-магазины (ecom)",
        to: routes.ecom,
        linkLabel: "Разработка интернет-магазинов",
        text: "Разрабатываем удобные и современные интернет-магазины, помогаем выстроить бизнес-процессы с нуля и усиливаем онлайн-продажи. Учитываем цели, масштаб и рынок вашей ниши.",
      },
      {
        title: "Корпоративные сайты",
        to: routes.corporate,
        linkLabel: "Корпоративные сайты",
        text: "Ваш сайт — это лицо компании. Помогаем разработать стратегию, которая поддерживает продажи, имидж и рост бренда в интернет-пространстве.",
      },
    ],
  },
  {
    id: "marketing",
    label: "Маркетинг",
    items: [
      {
        title: "SEO-продвижение",
        to: routes.seo,
        linkLabel: "SEO-продвижение сайтов",
        text: "Помогаем продвинуть сайт в поиске, избегая стандартных подходов. Аудит, стратегия, точная настройка контента под алгоритмы, что ведет к стабильному органическому трафику и росту позиций в поисковиках.",
      },
      {
        title: "Контекстная реклама",
        to: routes.context,
        linkLabel: "Ведение Яндекс Директа",
        text: "Настроим рекламу, которая привлечет клиентов, уже ищущих ваш продукт, и убедит их выбрать именно вас. Максимальная эффективность при минимальных потерях бюджета.",
      },
      {
        title: "Локальное продвижение (GEO Performance)",
        to: routes.geo,
        linkLabel: "Продвижение в геосервисах",
        text: "Настраиваем карточки компании в Яндекс, Google и 2ГИС, работаем с отзывами и повышаем видимость на картах. Геосервисы превращаются в стабильный канал привлечения клиентов рядом с вами.",
      },
    ],
  },
  {
    id: "crm",
    label: "CRM",
    items: [
      {
        title: "AmoCRM",
        to: routes.amocrm,
        linkLabel: "Внедрение amoCRM",
        text: "Единое пространство для управления сделками и хранения данных клиентов. Быстрый доступ к контактам, истории взаимодействий и текущим задачам. Интегрируется с любыми каналами привлечения — от звонков до мессенджеров — и автоматически собирает все лиды в одном месте.",
      },
      {
        title: "RetailCRM",
        to: routes.retailcrm,
        linkLabel: "Внедрение RetailCRM",
        text: "Полная цифровизация продаж и клиентского сервиса. Объединяем заказы из чатов, автоматизируем воронки, программы лояльности и рассылки. Все работает синхронно — для роста выручки и высокого уровня обслуживания.",
      },
      {
        title: "Битрикс24",
        to: routes.bitrix24,
        linkLabel: "Внедрение Битрикс24",
        text: "Автоматизируем бизнес-процессы, задачи и коммуникацию внутри компании. Настраиваем воронки, права доступа и отчетность так, чтобы отдел продаж работал прозрачно и предсказуемо.",
      },
    ],
  },
];
